var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4ProhibitedAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 7v52H53V17H23v42H12V7h52zM45 48.77l-6.89 6.89-6.9-6.89L28 52l6.9 6.9-6.9 6.87L31.17 69l6.9-6.9L45 69l3.21-3.2-6.9-6.9 6.9-6.9L45 48.77z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Prohibited_access.3f94726f.svg";
export { SvgE4ProhibitedAccess as ReactComponent };